import {combineReducers} from 'redux'
import yourElementsReducer from './yourElements.js';
import caseContentReducer from './caseContent.js';

const rootReducer = combineReducers({
    yourElements:yourElementsReducer,
    casecontent:caseContentReducer,
})

export default rootReducer